<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5 12.976a1 1 0 00-.426-.82A10.367 10.367 0 008 10.5a10.367 10.367 0 00-6.074 1.656 1 1 0 00-.426.82V15.5h13v-2.524zM8 7.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
